/**
 * LUNEMUR — Tiroir favoris (rendu de la liste, ouverture/fermeture).
 * Lit uniquement window.LunemurWishlist (localStorage) — jamais de requête réseau.
 */
(function () {
  'use strict';

  function boot() {
    var tab = document.querySelector('[data-lm-wish-tab]');
    var panel = document.querySelector('[data-lm-wish-panel]');
    if (!tab || !panel || !window.LunemurWishlist) return;

    var countEl = tab.querySelector('[data-lm-wish-count]');
    var body = panel.querySelector('[data-lm-wish-body]');
    var closeEls = panel.querySelectorAll('[data-lm-wish-close]');
    var lastFocused = null;

    function render() {
      var items = window.LunemurWishlist.list();
      tab.hidden = items.length === 0;
      if (countEl) countEl.textContent = items.length;

      body.textContent = '';
      if (items.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'lm-wish-panel__empty';
        empty.textContent = 'Aucun favori pour le moment.';
        body.appendChild(empty);
        return;
      }

      items.slice().reverse().forEach(function (item) {
        var row = document.createElement('article');
        row.className = 'lm-wish-item';

        var media = document.createElement('div');
        media.className = 'lm-wish-item__media';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        row.appendChild(media);

        var info = document.createElement('div');
        info.className = 'lm-wish-item__body';

        var title = document.createElement('p');
        title.className = 'lm-wish-item__title';
        var link = document.createElement('a');
        link.href = item.url || '#';
        link.textContent = item.title || '';
        title.appendChild(link);
        info.appendChild(title);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'lm-wish-item__remove';
        remove.textContent = 'Retirer';
        remove.addEventListener('click', function () {
          window.LunemurWishlist.remove(item.id);
        });
        info.appendChild(remove);

        row.appendChild(info);
        body.appendChild(row);
      });
    }

    function open() {
      panel.hidden = false;
      document.documentElement.classList.add('lm-wish-scroll-lock');
      lastFocused = document.activeElement;
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      panel.hidden = true;
      document.documentElement.classList.remove('lm-wish-scroll-lock');
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    tab.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });

    window.addEventListener(window.LunemurWishlist.EVENT_NAME, render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
